import * as service from "../service";
import { store } from "../../store";

/**
 * Change the password of the currently logged-in student.
 * Backend: PUT /api/user/editAccount/changePassword
 */
export const ChangePasswordAPI = async (password: string) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call("PUT", "api/user/editAccount/changePassword", {
      id: user?.id,
      password,
    });
    return resp;
  } catch (err) {
    console.error(`ChangePasswordAPI ${err}`);
    return { status: -1, resp: err };
  }
};
